<ul>
  <li><button (click)="selectLeague('PremierLeague')" type="button">Bundesliga</button></li>
  <li><button (click)="selectLeague('SecondLeague')" type="button">2. Bundesliga</button></li>
  <li><button (click)="selectLeague('ThirdLeague')" type="button">3. Liga</button></li>
  <li><button (click)="selectLeague('FourthLeague')" type="button">Regionalliga</button></li>
</ul>
